//open project

// export const BASEURL = `http://localhost:7500/api`

export const BASEURL = `api`;
// export const OPENPROJECT_LOGIN_UI_BASEURL = `https://open-project-login-dev.demo.connect.waymore.io/api`
export const OPENPROJECT_LOGIN_UI_BASEURL = process.env.REACT_APP_OPENPROJECT_LOGIN_UI_BASEURL
export const PMS_BASE_URL = `https://project-management.connect.waymore.io/api`

// Rokos LDAP API key
export const LDAP_API_TOKEN = '65562ae3991f2878372f16ae9468bab77778d4e68d76b8965ff3c96080cc393b'

// Guru LDAP API key
// export const LDAP_API_TOKEN = '70b54b474430c7d8dd805afaaa6c3c38bb9365be0a5559b17749c1c598af163d'`

// jira managment 

// export const JIRA_MANAGEMENT_BASEURL = `http://localhost:5000/api`
export const JIRA_MANAGEMENT_BASEURL = `https://jira-management.connect.waymore.io/api`
// export const JIRA_MANAGEMENT_BASEURL = `http://localhost:3500/api`
// export const JIRA_MANAGEMENT_BASEURL = `https://jira-management.demo.connect.waymore.io/api`

export const JIRA_USERNAME = 'software@waymore.io'
export const JIRA_TOKEN = 'ATATT3xFfGF0EUe9M_Nt2XNOPFuqaH65g6-CcQyhHIwi07zjHman-3XNgxjSCoNAKWHUAk8_yoyZnR4TzZirOWTJfDEPFZZvZXYY2YP9hW4uBI3dTK4bnMynyiyT_vfYeCvqaGOeSmUd4F9bXjdoDqH6FAIsA-FK2U51QlGJLxcWDG2U70fgXRk=DC3EADE6'


export const AMDTELECOM_ATLASSIAN_URL_WITH_BROWSE = 'https://amdtelecom.atlassian.net/browse/'
export const OPENPROJECT_AMDTELECOM_BASEURL = 'https://openproject.int.amdtelecom.net/'


export const UNIQUE_JIRA_OPENPROJECT_PROJECT_MANAGEMENT_MEETING_LABEL = "project_management_meeting";
export const JIRA_EPIC_ISSUE_ID = "10000";
export const JIRA_TASK_ISSUE_ID = "11067";
export const JIRA_SUBTASK_ISSUE_ID = "11094";
export const JIRA_TASK_IN_PROGRESS_STATUS = '31';
export const JIRA_TASK_IN_PROGRESS_STATUS_ID = "3";
export const JIRA_TASK_IN_REVIEW_STATUS_ID = "10300";
export const JIRA_TASK_BLOCKED_STATUS_ID = '10501';

export const CDN_MEETING_ATTACHMENT_FOLDER = "Attachments";

export const EMAIL_SUFFIX = {
    WAYMORE: '@waymore.io',
    AMDTELECOM: '@amdtelecom.net'
}

export const AI_CHAT_PLATFORMS = ['OPEN_PROJECT', 'WAY_MORE', 'JIRA',]

export const SECRET_KEY = 'projectManagement';

export const NOTIFICATION = 'Notification';
export const NOTIFICATION_PERMISSIONS = {
    DEFAULT: 'default',
    GRANTED: 'granted',
};
export const NOTIFICATION_TITLE = 'PMS Project Management System';
export const AMD_TELEcOM_BASEURL = 'https://amdtelecom.atlassian.net/';
export const WORK_LOG_PLUGIN = 'com.atlassian.plugins.atlassian-connect-plugin:com.soldevelo.apps.worklogs__worklog-project-page-jira#!';
export const LEAVE_MANAGEMENT_URL = process.env.REACT_APP_LEAVE_MANAGEMENT_URL;
// export const LEAVE_MANAGEMENT_URL = 'http://localhost:6100/api/';

export const CHAT_BOT_KNOWLEDGE_BASE_URL = 'https://chatbot-knowledgebase.connect.waymore.io/?token=2bgjaUvayou4SK6';
export const ORG_CHART_BASE_URL ='https://organizational-chart.connect.waymore.io/viewOrgCharts'
export const ORG_CHART_BASE_URL_ID='848c260d-f4c0-4582-9dec-360aafdfb73c'
export const COMMON_LANDING_PAGE_BASE_URL ='https://common.int.amdtelecom.net/'
export const CHATBOT_URL ='https://mini-chatbot.connect.waymore.io'
export const TASK_CATEGORIES = [
  "Support & Cleanup ",
  "Meetings & Collaboration",
  "Documentation & Knowledge Sharing",
  "Analysis & Design",
  "Testing & QA",
  "Code Review & Feedback",
  "Implementation",
  "Other",
];
